export function getRequestHost() {
    return window.location.origin || 'https://managermall.meituan.com';
}

export function getEnv(isFullInfo = false) {
    const hostMap = [
        {
            fullName: 'production',
            url: 'https://managermall.meituan.com'
        },
        {
            fullName: 'staging',
            url: 'http://manager.mall.st.sankuai.com'
        },
        {
            fullName: 'test',
            url: 'http://manager.mall.test.sankuai.com'
        },
        {
            fullName: 'development',
            url: 'http://localhost:8418'
        }
    ];

    const envObj = hostMap.find(item => item.url === location.origin) || hostMap[0];

    return isFullInfo ? envObj : envObj.fullName;
}
